import { render, staticRenderFns } from "./TabListPropertyManager.vue?vue&type=template&id=42b68c08"
import script from "./TabListPropertyManager.vue?vue&type=script&lang=js"
export * from "./TabListPropertyManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports